import React from 'react';
import SvgIcon from '../../../components/SvgIcon';
import Button from '../../../components/Button';

const Footer = ({ header, text, buttons, handlers = [() => {}, () => {}] }) => {
  const [firstButtonHandler, secondButtonHandler] = handlers;
  return (
    <div className="footer">
      <div className="header">
        <div className="icon">
          <SvgIcon name="arrowRightBig" />
        </div>
        {header}
      </div>
      <div className="bottom">
        <div className="text">{text}</div>
        <div className="flex flex-row items-center gap-2">
          <Button onClick={firstButtonHandler} variant="outline">
            {buttons[0]}
          </Button>
          <Button onClick={secondButtonHandler}>{buttons[1]}</Button>
        </div>
      </div>
    </div>
  );
};

export default Footer;
